export default __webpack_public_path__ + "static/media/corazon.e604cafe.svg";